import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatApiErrorDetail } from "@/context/AuthContext";
import { BRANDING } from "@/config/branding";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ui, GoldButton } from "@/components/Primitives";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [link, setLink] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(true);
      if (data.reset_link) setLink(data.reset_link); // Founder-beta convenience
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md fade-up">
        <div className="font-display text-3xl gold-text tracking-wider text-center mb-6">{BRANDING.name}</div>
        <div className="glass-card rounded-3xl p-8">
          {!done ? (
            <>
              <h1 className="font-display text-2xl font-light text-[#2C2A28] mb-2">Reset your password</h1>
              <p className="text-[#8A7F70] text-sm mb-6">Enter your email and we'll create a secure reset link.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label className={ui.label}>Email</Label>
                  <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={ui.input} placeholder="you@email.com" />
                </div>
                {err && <div className="text-sm text-[#b06b6b] bg-[#C99FA0]/15 border border-[#C99FA0]/30 rounded-xl px-4 py-3">{err}</div>}
                <GoldButton data-testid="forgot-submit" type="submit" disabled={loading} className="w-full h-12">
                  {loading ? <Loader2 className="animate-spin" size={20} /> : "Send reset link"}
                </GoldButton>
              </form>
            </>
          ) : (
            <div className="text-center">
              <div className="w-14 h-14 rounded-full bg-[#F0E7D8] flex items-center justify-center mx-auto mb-4"><MailCheck size={24} className="text-[#C6A45C]" /></div>
              <h1 className="font-display text-2xl font-light text-[#2C2A28] mb-2">Check your inbox</h1>
              <p className="text-[#8A7F70] text-sm">If that email exists, a reset link has been created and is valid for one hour.</p>
              {link && (
                <Link to={link.substring(link.indexOf("/reset-password"))} data-testid="forgot-dev-link"
                  className="mt-4 inline-block text-sm gold-text underline break-all">Open reset link</Link>
              )}
            </div>
          )}
          <div className="mt-6 text-center">
            <Link to="/auth" className="text-sm text-[#8A7F70] hover:text-[#2C2A28] inline-flex items-center gap-1"><ArrowLeft size={14} /> Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
